import React, { useCallback, useEffect, useState } from 'react';
import { DropdownIconContainer } from '../../Select.styled';
import { Icon } from '@citrus/icon';
import { dropdownIcon } from '../../../styles/citron';
import { css as emotionCss, cx } from 'emotion';
var DropdownIcon = function (_a) {
    var _b;
    var disabled = _a.disabled, config = _a.config, isOpen = _a.isOpen, closeMenu = _a.closeMenu, openMenu = _a.openMenu;
    var _c = useState(false), toggle = _c[0], setToggle = _c[1];
    var iconName = isOpen ? 'collapse' : 'expand';
    var toggleIsOpen = useCallback(function () {
        if (disabled) {
            return;
        }
        isOpen ? closeMenu() : openMenu();
    }, [disabled, isOpen, closeMenu, openMenu]);
    useEffect(function () {
        if (config.toggle !== toggle) {
            setToggle(config.toggle);
        }
        if (config.toggle && config.toggle !== toggle) {
            toggleIsOpen();
        }
    }, [config, toggle, toggleIsOpen]);
    var emotionObj = (_b = {},
        _b[emotionCss(dropdownIcon)] = true,
        _b);
    var classes = cx(emotionObj);
    return (React.createElement(DropdownIconContainer, { onMouseDown: toggleIsOpen },
        React.createElement(Icon, { className: classes, name: iconName, size: "small", title: iconName })));
};
export default DropdownIcon;
